// extracted by mini-css-extract-plugin
export default {"report-modal":"styles_report-modal__Uz6uZ","reportModal":"styles_report-modal__Uz6uZ"};